import type { ResultListItem } from "../types";
import { apiClient } from "./apiClient";
export const resultsApi = { list: () => apiClient<ResultListItem[]>("/results") };

